/*
 * Dawn compatibility — single owner for all Dawn prototype patches.
 * SM never touches Dawn internals elsewhere (AGENTS.md rule 1).
 * This file is the only place that monkey-patches Dawn.
 *
 * Patches:
 *  - CartDrawer.getSectionsToRender  → request only real section cart-drawer
 *  - CartDrawerItems.getSectionsToRender → request only cart-drawer
 *  - CartDrawer.renderContents → sync is-empty host class (Dawn bug: host never updated)
 *
 * Each patch checks that the expected Dawn method exists and fails loudly
 * if a theme update removes it (so the integration doesn't silently break).
 */
(function () {
  "use strict";

  if (window.smDawnCartCompatReady) return;
  window.smDawnCartCompatReady = true;

  function assertMethod(proto, method, label) {
    if (!proto) {
      console.error(
        "[SM DawnCompat] Missing prototype for " +
          label +
          " — cannot patch " +
          method +
          ".",
      );
      return false;
    }
    var actual = typeof proto[method];
    if (actual !== "function") {
      var themeName =
        (window.Shopify &&
          Shopify.theme &&
          (Shopify.theme.name || Shopify.theme.theme_store_id)) ||
        "unknown";
      var assetVer = document.querySelector('script[src*="main.js"]');
      assetVer = assetVer ? assetVer.getAttribute("src") : location.href;
      console.error(
        "[SM DawnCompat] Incompatible Dawn API: " +
          label +
          "." +
          method +
          " expected function, got " +
          actual +
          ". Theme: " +
          themeName +
          " Asset: " +
          assetVer +
          " — cart drawer compat may be broken after theme update. Check sm-cart-dawn-compat.js.",
      );
      return false;
    }
    return true;
  }

  function patchCartDrawer() {
    var CartDrawer = customElements.get("cart-drawer");
    if (!CartDrawer) return;
    var proto = CartDrawer.prototype;
    if (proto.__smPatchedSections) return;
    if (!assertMethod(proto, "getSectionsToRender", "CartDrawer")) return;
    proto.__smPatchedSections = true;
    proto.getSectionsToRender = function () {
      return [{ id: "cart-drawer", selector: "#CartDrawer" }];
    };
  }

  function patchCartDrawerItems() {
    var CartDrawerItems = customElements.get("cart-drawer-items");
    if (!CartDrawerItems) return;
    var proto = CartDrawerItems.prototype;
    if (proto.__smPatchedSections) return;
    if (!assertMethod(proto, "getSectionsToRender", "CartDrawerItems")) return;
    proto.__smPatchedSections = true;
    proto.getSectionsToRender = function () {
      return [
        {
          id: "CartDrawer",
          section: "cart-drawer",
          selector: ".drawer__inner",
        },
      ];
    };
  }

  function patchCartDrawerIsEmptySync() {
    var CartDrawer = customElements.get("cart-drawer");
    if (!CartDrawer) return;
    var proto = CartDrawer.prototype;
    if (proto._smIsEmptyPatched) return;
    if (!assertMethod(proto, "renderContents", "CartDrawer")) return;
    proto._smIsEmptyPatched = true;
    var orig = proto.renderContents;
    proto.renderContents = function (resp, keepCurrent) {
      var result = orig.call(this, resp, keepCurrent);
      // Dawn replaces #CartDrawer innerHTML but never touches the host
      // classList. Sync is-empty so open()’s transitionend picks the
      // correct focus target (is-empty → query <a> → null → crash).
      var hasItems =
        this.querySelectorAll("#CartDrawer-CartItems .cart-item").length > 0;
      if (hasItems) this.classList.remove("is-empty");
      else this.classList.add("is-empty");
      return result;
    };
  }

  function patchAll() {
    patchCartDrawer();
    patchCartDrawerItems();
    patchCartDrawerIsEmptySync();
  }

  if (customElements.get("cart-drawer")) patchAll();
  else customElements.whenDefined("cart-drawer").then(patchAll);

  if (customElements.get("cart-drawer-items")) patchCartDrawerItems();
  else
    customElements.whenDefined("cart-drawer-items").then(patchCartDrawerItems);
})();
